export enum LogoPosition {
  LEFT = 'left',
  CENTER = 'center',
}
